export default "__VITE_ASSET__I99kqw3j__"